<template>
  <main class="domain-move-notice">
    <section class="notice-card" aria-labelledby="domain-move-title">
      <div class="color-mark" aria-hidden="true">
        <span class="color-mark__circle color-mark__circle--blue"/>
        <span class="color-mark__circle color-mark__circle--yellow"/>
        <span class="color-mark__circle color-mark__circle--red"/>
      </div>

      <p class="eyebrow">Therapeutic Color Indicator</p>
      <h1 id="domain-move-title">We've moved to a new web address</h1>
      <p class="notice-copy">
        Please update your bookmark so you can continue using the
        Therapeutic Color Indicator at its new home.
      </p>
      <a
        class="new-site-link"
        :href="newSiteUrl"
      >
        Visit the new site
        <span aria-hidden="true">&rarr;</span>
      </a>
      <p class="new-address">
        <span>New address</span>
        <strong>{{ displayUrl }}</strong>
      </p>
    </section>
  </main>
</template>

<script>
  export default {
    name: 'DomainMoveNotice',
    props: {
      newSiteUrl: {
        type: String,
        required: true,
      },
    },
    computed: {
      displayUrl() {
        return this.newSiteUrl.replace(/^https?:\/\//, '');
      },
    },
  };
</script>

<style scoped>
  .domain-move-notice {
    align-items: center;
    background:
      radial-gradient(circle at 15% 20%, rgba(60, 157, 207, 0.18), transparent 28rem),
      radial-gradient(circle at 85% 80%, rgba(238, 174, 48, 0.18), transparent 28rem),
      #f5f7f4;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem 1.25rem;
  }

  .notice-card {
    background: #fff;
    border-radius: 1.25rem;
    box-shadow: 0 1.25rem 4rem rgba(37, 57, 68, 0.13);
    box-sizing: border-box;
    max-width: 42rem;
    padding: 3.5rem 3rem;
    width: 100%;
  }

  .color-mark {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
  }

  .color-mark__circle {
    border: 0.25rem solid #fff;
    border-radius: 50%;
    display: block;
    height: 2.75rem;
    margin-left: -0.65rem;
    width: 2.75rem;
  }

  .color-mark__circle:first-child {
    margin-left: 0;
  }

  .color-mark__circle--blue {
    background: #368db9;
  }

  .color-mark__circle--yellow {
    background: #e9b13e;
  }

  .color-mark__circle--red {
    background: #cb5d52;
  }

  .eyebrow {
    color: #527180;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    margin-bottom: 0.75rem;
    text-transform: uppercase;
  }

  h1 {
    color: #203844;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 auto 1.25rem;
  }

  .notice-copy {
    color: #536873;
    font-size: 1.1rem;
    line-height: 1.7;
    margin: 0 auto 2rem;
    max-width: 33rem;
  }

  .new-site-link {
    background: #2d768f;
    border-radius: 0.6rem;
    color: #fff;
    display: inline-block;
    font-size: 1.05rem;
    font-weight: 700;
    padding: 0.9rem 1.5rem;
    text-decoration: none;
    transition: background 150ms ease, transform 150ms ease;
  }

  .new-site-link:hover,
  .new-site-link:focus {
    background: #235f74;
    color: #fff;
    text-decoration: none;
    transform: translateY(-1px);
  }

  .new-site-link span {
    margin-left: 0.4rem;
  }

  .new-address {
    color: #6d7b82;
    font-size: 0.9rem;
    margin: 1.5rem 0 0;
  }

  .new-address span,
  .new-address strong {
    display: block;
  }

  .new-address strong {
    color: #405761;
    font-weight: 600;
    margin-top: 0.25rem;
    overflow-wrap: anywhere;
  }

  @media (max-width: 36rem) {
    .notice-card {
      padding: 2.5rem 1.5rem;
    }

    h1 {
      font-size: 1.75rem;
    }

    .notice-copy {
      font-size: 1rem;
    }
  }
</style>
